import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorageValue } from "../helpers/localStoreManager";

const localStorageAuth = "localStorageAuth";

const getInitialAuthState = () => {
  try {
    const persistedState = getLocalStorageValue(localStorageAuth);
    if (persistedState) {
      return JSON.parse(persistedState);
    }
  } catch (error) {
    console.error("Error loading state from localStorage:", error);
    localStorage.setItem(localStorageAuth, JSON.stringify({}));
  }
  return initialAuthState;
};

const initialAuthState = {
  isAuthenticated: false,
  email: null,
  password: null,
  jwt_token: null,
};

const authSlice = createSlice({
  name: "authentication",
  initialState: getInitialAuthState(),
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.jwt_token = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.jwt_token = null;
    },
    setEmail(state, action) {
      state.email = action.payload;
    },
    setPassword(state, action) {
      state.password = action.payload;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
